export const FanBucks = [
  { id: 'copper', color: '#dc3c08', value: 100 },
  { id: 'silver', color: '#a7a7a7', value: 200 },
  { id: 'emerald', color: '#38cc93', value: 500 },
  { id: 'gold', color: '#f7be2b', value: 1000 },
  { id: 'indigo', color: '#A294FF', value: 2000 }
];
